export const furnitureModal = [
  {
    type: 'title',
    content: 'Delivery Methods'
  },
  {
    type: 'paragraph',
    content: [
      '',
      'Suggested delivery method(s) will automatically be applied to the items in your cart.',
    ]
  },
  {
    type: 'paragraph',
    content: [
      'Entryway',
      'Our entryway service delivers the packaged item to the first room of the address. The recipient is then responsible for moving the item farther into the home.',
    ],
    customClass: 'mt-6 font-bold'
  },
  {
    type: 'styledTable',
    content: {
      title: '',
      rows: [
        [
          [
            '# of Items',
          ],
          [
            'Shipping',
          ],
        ],
        [
          ['1 item'],
          ['$179'],
        ],
        [
          ['2 items'],
          ['$229'],
        ],
        [
          ['3 or more'],
          ['$279'],
        ],
      ]
    }
  },
  {
    type: 'paragraph',
    content: [
      'White-Glove',
      'Our white-glove service delivers the item to the recipient’s room of choice, assembles the item, and disposes of the packaging. Some white-glove items are eligible for entryway delivery.',
    ],
    customClass: 'mt-6 font-bold'
  },
  {
    type: 'styledTable',
    content: {
      title: '',
      rows: [
        [
          [
            '# of Items',
          ],
          [
            'Shipping',
          ],
        ],
        [
          ['1 item'],
          ['$279'],
        ],
        [
          ['2 items'],
          ['$329'],
        ],
        [
          ['3 or more'],
          ['$379'],
        ],
      ]
    }
  },
  {
    type: 'link',
    content: {
      title: 'Learn More',
      url: '/faq/#shipping-delivery'
    }
  }
]